<template>
  <div id="app" class="public-knowledge">
    <!-- 这种写法 可以将路由配置到router内 -->
    <router-view v-if="isConfigReady && (!$route.meta || !$route.meta.keepAlive)"></router-view>
    <keep-alive>
      <router-view v-if="isConfigReady && $route.meta && $route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import Api, { LoadConfig } from '@/service';
import util from '@/util';

export default {
  data() {
    return {
      isConfigReady: false,
    }
  },

  computed: {
    autoGrow() {
      const urlParams = util.getUrlParams();
      const autoGrow = (this.$route && this.$route.query.autoGrow) || urlParams.autoGrow;
      return autoGrow == 1;
    },
  },
  methods: {
    examineIdentifier() {
      const queryConfig = new LoadConfig({
        loadingMsg: $t('链接校验中...'),
      });
      const identifier = util.getUrlParams().identifier;

      if (!identifier) {
        this.isConfigReady = true;
        return;
      };

      Api.config({ identifier }, queryConfig)
        .then(res => {
          const { isValidIdentifier, scene } = res.data || {};
          scene && localStorage.setItem(util.global.SCENARY_CACHE_NAME, scene);

          this.isConfigReady = true;

          return isValidIdentifier
            ? null
            : {
                name: 'error',
                params: {
                  errMsg: $t('链接已失效！'),
                },
              };
        })
        .catch(errMsg => {
          return {
            name: 'error',
            params: {
              errMsg,
            },
          };
        })
        .then(toRoute => {
          toRoute && this.$router.replace(toRoute);
        });
    },
  },
  created() {
    this.examineIdentifier();
    const width = document.body.offsetWidth;
    if (width > 1000) {
      document.body.classList.add('pc');
    }
    if (this.autoGrow) {
      document.getElementsByTagName('html')[0].classList.add('auto-grow');
    }
  },
};
</script>
<style lang="less">
body {
  box-sizing: border-box;
}

.public-knowledge {
  max-width: 1000px;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}

wx-title-bar {
  display: none;
}
</style>
